/**
 * Hooks Barrel Export
 * Centralized export point for all custom hooks
 */

// Base hooks
export { default as useApi } from './useApi';

// Material hooks
export {
  default as useMaterialAllData,
  useAllMaterials,
  useSectors,
  useTopSectors,
  useRecentViews,
  useSectorMaterials,
  useMaterialGeneral,
  useMaterialChartOverview,
  useMaterialChartSeries,
  useMaterialAssessment,
  useMaterialAvailability,
  useMaterialCountryProduction,
  useMaterialMarketStability,
  useMaterialNeedProjection,
  useMaterialRecentDaily,
  useMaterialRollingAverage,
  useMaterialComparison,
  useReferenceCurrencies,
  useReferenceUnits,
} from './useMaterialData';

// Product hooks
export {
  default as useProductOverview,
  useProductRisk,
  useProductRegulatory,
  useProductInsights,
  useProductSources,
  useProductRollingAverages,
  useProductRollingAverageSeries,
  useProductChartOverview,
  useProductList,
  useProductSectors,
  useProductRecentViews,
  useProductRelatedSectors,
  useSectorProducts,
  useProductDetail,
  useProductGeneral,
  useProductChartComparison,
  useProductChartSeries,
  useProductClassification,
  useProductRecentDaily,
  useProductTableAverage,
  useProductSearch,
  useAllProducts,
  useProductSearchOptions,
  useProductAllData,
} from './useProductData';

// Existing utility hooks
export { default as useBreakpoint } from '../utils/useBreakPoint';

// Future hooks (when implemented)
// export { default as useNewsData } from './useNewsData';
// export { default as useDashboardData } from './useDashboardData';
// export { default as useCompanyData } from './useCompanyData';
// export { default as useInsightsData } from './useInsightsData';
